import { Component, Input, OnInit } from '@angular/core';
import { ErrorService } from '@uw/core/services/error.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Observable, delay, map } from 'rxjs';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-alert-message-box',
    templateUrl: './alert-message-box.component.html',
    styleUrls: ['./alert-message-box.component.scss'],
    imports: [MatIconButton, MatIcon, AsyncPipe, TranslateModule]
})
export class AlertMessageBoxComponent implements OnInit {
  error$: Observable<string | null>;

  @Input()
  errorMessage: string | null = null;

  constructor(
    private errorService: ErrorService,
    private translateService: TranslateService
  ) {
    this.error$ = this.errorService.getError().pipe(
      delay(0),
      map((err) => (err ? translateService.instant(err) : null))
    );
  }

  ngOnInit(): void {}

  onDismiss() {
    this.errorService.resetError();
  }

  onErrorDismiss() {
    this.errorMessage = null;
  }
}
